import AuswahlwerteApi from "@/api/AuswahlwerteApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";

const AuswahlwerteController = {

  /**
   * Übersetzt ein Auswahlwert-Objekt (JSON) über die API
   * @param {Object} payload - das zu übersetzende JSON-Objekt
   * @returns {Promise<AxiosResponse<any>>} - die Antwort mit den Übersetzungen
   */
  async translate(payload) {
    try {
      const response = await AuswahlwerteApi.post("/translate", payload);
      return response.data;
    } catch (error) {
      this.$notify(apiErrorToAlert(error));
    }
  }
};

export default AuswahlwerteController;
